import { Controller } from "@hotwired/stimulus";
import DataTable from "datatables.net-dt";
import language from "datatables.net-plugins/i18n/es-MX.mjs";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
export default class default_1 extends Controller {
    get tabla() {
        if (this.element instanceof HTMLTableElement) {
            return this.element;
        }
        throw new Error("This controller's element is not an HTMLTableElement.");
    }
    connect() {
        const tabla = this.tabla;
        if (DataTable.isDataTable(tabla)) {
            this.$dataTable = new DataTable(tabla);
        }
        else {
            this.$dataTable = new DataTable(tabla, {
                language,
                ajax: this.dataUrlValue,
                columns: [
                    { data: "id", title: "ID" },
                    { data: "codigoHacienda", title: "Código Hacienda" },
                    { data: "mensajeHacienda", title: "Mensaje de Hacienda" },
                    { data: "mensajePersonalizado", title: "Mensaje personalizado" },
                ],
                responsive: true,
                select: {
                    items: "row",
                    style: "single",
                },
                processing: true,
            });
            this.$dataTable
                .on("select", () => {
                const $fila = this.$dataTable.row("*", { selected: true });
                if ($fila.any()) {
                    this.dispatch("seleccionado", {
                        detail: $fila.data(),
                        bubbles: true,
                    });
                }
            })
                .on("deselect", () => {
                this.dispatch("deseleccionado", {
                    bubbles: true
                });
            });
        }
    }
    recargarDatos() {
        this.$dataTable.ajax.reload().draw();
    }
}
default_1.values = {
    dataUrl: String,
};
//# sourceMappingURL=tabla_controller.js.map